<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)"
             size = "medium"
             color = "#fff"
             type = "ball-spin-clockwise-fade"
             [fullScreen] = "true"
             [zIndex]="999999999"
             >
  <p style="color: white" > Loading... </p>
</ngx-spinner>
